import { NotificationsContainer } from '../containers/NotificationsContainer/index'

export const NotificationsPage = () => (
    <NotificationsContainer/>
)